import { useState } from 'react';
import { toast } from 'sonner';
import { useLiveKit } from '../contexts';
import { updateCameraResolution } from '../api/api-setting-meeting';
export function ParticipantResolutionSelect({
    identity,
    disabled,
}: {
    identity: string;
    disabled?: boolean;
}) {
    const { meeting, cameraResolutionPolicy } = useLiveKit();
    const [busy, setBusy] = useState(false);
    const target = cameraResolutionPolicy?.targets[identity];

    return (
        <div className="grid gap-1 text-xs">
            <select
                aria-label={`Độ phân giải ${identity}`}
                className="h-8 rounded border bg-background px-2"
                value={target?.configuredResolution ?? ''}
                disabled={disabled || busy || !meeting}
                onChange={async e => {
                    if (!meeting) return;
                    setBusy(true);
                    try {
                        await updateCameraResolution(meeting.id, e.target.value, { identity });
                        toast.success('Đã lưu độ phân giải');
                    } catch {
                        toast.error('Không cập nhật được độ phân giải');
                    } finally {
                        setBusy(false);
                    }
                }}
            >
                <option value="" disabled>Chọn độ phân giải</option>
                {[
                    '90p', '180p', '216p', '240p', '360p', '480p',
                    '720p', '960p', '1080p', '1440p', '2160p',
                ].map(r => (
                    <option key={r} value={r}>{r}</option>
                ))}
            </select>

            <select
                aria-label={`FPS ${identity}`}
                className="h-8 rounded border bg-background px-2"
                value={target?.configuredFps ?? 30}
                disabled={disabled || busy || !meeting}
                onChange={async e => {
                    if (!meeting) return;
                    setBusy(true);
                    try {
                        await updateCameraResolution(
                            meeting.id,
                            undefined,
                            { identity },
                            Number(e.target.value)
                        );
                        toast.success('Đã lưu FPS');
                    } catch {
                        toast.error('Không cập nhật được FPS');
                    } finally {
                        setBusy(false);
                    }
                }}
            >
                {[5, 10, 15, 20, 24, 25, 30, 60].map(n => (
                    <option key={n} value={n}>{n} fps</option>
                ))}
            </select>
        </div>
    );
}